import { map, is } from 'ramda';
import moment from 'moment';
import { SortType } from '../enums/SortType';
import { OrderType } from '../enums/OrderType';
import { ISortItem } from '../models/filter/ISortItem';
import { ISortItemReq } from '../models/filter/ISortItemReq';
import { IDateFilter } from '../models/filter/IDateFilter';
import { IFilterItem } from '../models/filter/IFilterItem';

export const getSortingValues = (sortType: SortType) => {
  switch (sortType) {
    case SortType.Numeric:
      return { from: 0, to: 9 };
    case SortType.Literal:
    default:
      return { from: 'A', to: 'Z' };
  }
};

export const parseDateToUtc = ({ from, to }: IDateFilter): IDateFilter => ({
  from: from && new Date(moment.utc(from).format()),
  to: to && new Date(moment.utc(to).add(1, 'd').format())
});

export const mapFilterToFilterReq = (filter: IFilterItem[]): IFilterItem[] => map(({ value, id }) => ({
  value: is(String, value) ? value : parseDateToUtc(value as IDateFilter),
  id
}), filter);

export const mapSortToSortReq = (sort: ISortItem[]): ISortItemReq[] => map(({ desc, id }) => ({
  id,
  order: desc ? OrderType.Desc : OrderType.Asc
}), sort);
